<template>
<div>
    <h1 class="pt-2 text-sm"> {{$t('form.documents.documents')}} </h1>
    <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
        <template v-for="(doc, docIndex) in data">
            <div class="py-3" :key="'doc-' + docIndex">
                <div class="flex items-center justify-between">
                    <div>
                        <div class="font-bold">{{$tt(doc.type)}}</div>
                        <div class="mr-2 text-xs" v-if="doc.info" v-html="$tt(doc.info)"></div>
                    </div>
                    <a v-if="doc.url" :href="doc.url" target="_blank" class="text-xs font-light text-blue-500 hover:underline">
                        <i class="mr-1 fas fa-download"></i> {{$t('form.documents.telecharger_le_fichier')}}
                    </a>
                </div>
            </div>
        </template>
    </div>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'sav-files',
    extends: FormCardExtension,

    methods: {
        async init() {
            // Start of loading
            this.loading = true

            // Check if there are documents
            const response = await apiService.post('getdetailcase', {
                id_case: JSON.parse(this.$formTool.getFormData('set-case')).id_case
            })

            // File filters
            const hiddenFiles = ['Facture', 'Photo']
            const files = response.data.posts.post.documents
            const filesArray = []

            files.forEach((file) => {
                if (!hiddenFiles.includes(file.type)) {
                    filesArray.push(file)
                }
            })
            this.data = filesArray

            // Manage not files
            if (!this.data || this.data.length <= 0) {
                this.nextBlock = this.getNextBlock()
                this.$parent.hideBlockByName(this.$options.name)
                this.emitChange()
            } else {
                this.nextBlock = this.getNextBlock()
                this.emitChange()
            }

            // End of loading
            this.loading = false
        },

        end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            this.nextBlock = this.getNextBlock()
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
        },

        getNextBlock() {
            return this.$formTool.blockData(this.$options.name).next
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/procedure/Components/SavFilesCard.vue